import { render, staticRenderFns } from "./ServiceTable.vue?vue&type=template&id=56211388&scoped=true"
import script from "./ServiceTable.vue?vue&type=script&lang=js"
export * from "./ServiceTable.vue?vue&type=script&lang=js"
import style0 from "./ServiceTable.vue?vue&type=style&index=0&id=56211388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56211388",
  null
  
)

export default component.exports